import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

const DeleteModal = ({ open, rowName, onConfirm, onClose }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
    fullWidth
    sx={{
      '& .MuiDialog-paper': {
        marginTop: '10vh',
        borderRadius: '8px',
      },
    }}
  >
    <DialogTitle>Delete Row</DialogTitle>
    <DialogContent>
      <p>Are you sure you want to delete "<strong>{rowName}</strong>"?</p>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="secondary">
        Cancel
      </Button>
      <Button onClick={onConfirm} color="error">
        Delete
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteModal;